module.exports = function(rows) {
  var columns = Object.keys(rows[0] || {});

  var csvContent = rows.map(function(row) {
    return columns.map(function(c) {return row[c];}).join(",");
  }).join("\n");

  var encodedUri = encodeURI(
    "data:text/csv;charset=utf-8," +
    columns.join(',') + '\n' +
    csvContent
  );

  var link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "users.csv");
  document.body.appendChild(link); // Required for FF

  link.click();
  setTimeout(function() {
    link.remove();
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/export-csv.js
 ** module id = 380
 ** module chunks = 0
 **/